import {
  any, boolean, date, nullable,
  number, object, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateVenueMask = {
  availableDay: any,
  availableMonth: any,
  availableStart: date,
  availableTimes: any,
  averageTicketCost: number,
  civicAddress: string,
  civicAddress2: string,
  comments: string,
  communicationType: string,
  compiledAddress: string,
  createdAt: any,
  defaultStripeAccountId: string | nullable,
  firstInteractionTimestamp: date | nullable,
  fullName: string,
  hasBankingInformation: boolean,
  hasExperience: boolean,
  hasLocationOverride: boolean,
  hasMultipleVenues: boolean,
  hostEmail: string,
  hostNumShows: string,
  hostStatus: object,
  interestedInSaferSpaces: boolean,
  isVenueOwner: boolean,
  pendingShowReviewId: string | nullable,
  pendingVenueOwnerPermission: boolean,
  latLng: any,
  googlePlaceId: string,
  notesInternal: string,
  otherVenueDescription: string,
  phoneNumber: string,
  preferredActTypes: any,
  preferredFrequency: any,
  preferredMusicTypes: any,
  referralSource: string,
  requestedArtists: string,
  takesTenPercent: string,
  wantsProfit: boolean,
  reallyWantsProfit: boolean,
  updatedAt: any,
  lastOnlineAt: date,
  numShowsFinished: number,
  defaultHyperwalletAccountId: string | nullable,
  identities: any,
  sexualities: any,
  genders: any,
  disability: string,
};
